import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { paypalSubscription, stripeDecode, updatePayment } from "./service";
import Translate from "../../../Components/MultiLanguage/Translate";
import { bogSubscriptionCheck } from "../../../Screens/Subscription/service";
import { toast } from "react-toastify";
const PaymentSuccess = () => {

  const location = useLocation();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);

  let isFromAndroid = localStorage.getItem("isAndroid");
  let subscription_id = localStorage.getItem("subscription_id")
  let bogOrderId = localStorage.getItem("bogOrderId");
  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {

    const sessionId = urlParams.get("session_id");
    const ideabizData = location?.state?.ibr;
    const paypalData = urlParams.get("subscription_id") || urlParams.get("token") || urlParams.get("amt");
    const paypalSubId = urlParams.get("sub_id");
    const cinetPayFlag = urlParams.get("cinetPay")
    const squareFlag = urlParams.get("square")

    if (sessionId) {
      fetchStripeDecode(sessionId)
    } else if (paypalData) {
      let modeOfPayment = "paypal"
      updatePaymentApi(paypalData, modeOfPayment, null, paypalSubId)
    } else if (ideabizData) {
      let modeOfPayment = "ideabiz"
      updatePaymentApi(ideabizData, modeOfPayment)
    } else if (cinetPayFlag) {
      setPaymentSuccess(true)
    } else if (squareFlag) {
      let modeOfPayment = "square"
      let receiptid = subscription_id;
      updatePaymentApi(receiptid, modeOfPayment)
    } else if (bogOrderId) {
      BogSubscriptionStatus();
    }
  }, []);

  const paypalSusbscriptionApi = () => {
    const subID = localStorage.getItem("selectedSubId");

    let myInterval = setInterval(async () => {
      const response = await paypalSubscription(appInfo, subID);
      if (response?.status === 201) {
        clearInterval(myInterval);
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          window.location.href = process.env.REACT_APP_WEB_VIEW_SUCCESS;// android succes redirect
        } else {
          // setIsLoading(false);
          // setIsSucces(true);
        }
      }
    }, 10 * 1000)
  }

  let intervalId = null; 

  const BogSubscriptionStatus = async () => {
    
    if (!bogOrderId) return;
  
    let retries = 0;
    const MAX_RETRIES = 36; 
  
    const checkStatus = async () => {
      try {
        const response = await bogSubscriptionCheck(appInfo, bogOrderId);
  
        if (response?.data?.status === "SUCCESS") {
            let modeOfPayment = "bog"
            await updatePaymentApi(bogOrderId, modeOfPayment);
            clearInterval(intervalId); 
            intervalId = null;
        } else if (retries >= MAX_RETRIES) {
          clearInterval(intervalId); 
          intervalId = null;
        } else {
          retries++;
        }
      } catch (error) {
         toast.error(error?.response?.data?.message, { position: "bottom-center", });
      }
    };
  
    if (!intervalId) {
      intervalId = setInterval(checkStatus, 5000); 
    }
  };
  const updatePaymentApi = async (subscription, modeOfPayment, isUpgrade, subscriptionId) => {
    try {
      const updatePaymentResponse = await updatePayment(appInfo, subscription, modeOfPayment, "success", isUpgrade, subscriptionId);
      if (updatePaymentResponse?.status === 200) {
        setPaymentSuccess(true)
        localStorage.removeItem("couponId");
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          const webviewsuccess = projectInfo?.projectConfig?.config?.ANDROID_PAYMENT_SUCCESS_URL;
          window.location.href = webviewsuccess;  // android success redirect
        } else {
          // setIsLoading(false);
          // setIsSucces(true);
        }
      }

    } catch (err) {
      const response = await updatePayment(appInfo, subscription, modeOfPayment, "failed", null, subscriptionId)
      if (response?.status === 200) {
        setPaymentSuccess(true)
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          const webviewfailed = projectInfo?.projectConfig?.config?.ANDROID_PAYMENT_FAILED_URL;
          window.location.href = webviewfailed // android error redirect
        } else {
          navigate("/payment-failed")
        }
      }

    }
  }


  const fetchStripeDecode = async (sessionId) => {
    const stripeDecodeResponse = await stripeDecode(appInfo, sessionId)
    if (stripeDecodeResponse?.status === 200) {
      const subscription = stripeDecodeResponse?.data?.data?.subscription;
      let modeOfPayment = 'stripe'
      updatePaymentApi(subscription, modeOfPayment)
    }
  }

  const handleClick = () => {
    const showId = localStorage.getItem("showId");
    const eventId = localStorage.getItem("eventId");
    const eventType = localStorage.getItem("eventType");
    const vanityUrl = localStorage.getItem("vanityUrl")
    const redirectURL = localStorage.getItem("redirectURL");
    const isAndroid = localStorage.getItem("isAndroid")
    if (isAndroid == "true") {
      window.location.href = window.location.origin + "/webviewfailed"; // android error redirect
    } else if (eventId) {
      if (eventType === "UPCOMING") {
        navigate(`/event/${vanityUrl}`, { state: { eventId: eventId } })
      } else {
        navigate(`/player`, { state: { eventId: eventId } })
      }
    } else if (redirectURL) {
      localStorage.setItem('paymentSuccess', 'true');
      localStorage.removeItem("redirectURL");
      navigate(redirectURL)
    }
    else if (vanityUrl) {
      localStorage.setItem('paymentSuccess', 'true');
      navigate(`/show-details/${vanityUrl}`, { state: { showId } })
    }
    else {
      navigate("/home")
    }

    setTimeout(() => {
      // Forces a full reload of the new page to call athe authentication API to reset the resubscribe flag
      if (userDetails?.user_subscription_id) {
        window.location.href = window.location.href;
      }
    }, 2000);
  }

  if (paymentSuccess) {
    return (
      <div className="success">
        <div className="successContainer">
          <div className="checkIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="92"
              height="92"
              fill="#fff"
              className="bi bi-check2"
              viewBox="0 0 16 16"
            >
              <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
            </svg>
          </div>
          <h5><Translate textKey={'success'} /></h5>
          <p><Translate textKey={'payment_success_message'} /></p>
          {
            isFromAndroid !== "true" &&
            <button onClick={() => handleClick()}><Translate textKey={'ok'} /></button>
          }
        </div>
      </div>
    );

  } else {
    return (
      <div className="success">
        <div className="successContainer">
          <p className="checking"><Translate textKey={'payment_checking_inprogress'} /></p>

        </div>
      </div>
    )
  }
};

export default PaymentSuccess;
